/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_No_Spaces_Get_StartedInputs */



/**
* | output |
* | --- |
* | "Get started by creating your first space" |
*
* @param {Spaces_No_Spaces_Get_StartedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_no_spaces_get_started = /** @type {((inputs?: Spaces_No_Spaces_Get_StartedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_No_Spaces_Get_StartedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Beginne damit, deinen ersten Space zu erstellen")
	return /** @type {LocalizedString} */ ("Get started by creating your first space")
});